import styled, { css } from 'styled-components';

import Link from 'Elements/Link';

export const Container = styled.figure`
    position: relative;
    margin: 0;

    .lyt-playbtn {
        filter: none;
        transition: transform 0.25s ease-in-out;

        &:hover,
        &:focus {
            transform: scale(1.15);
        }
    }
`;

export const ContentPlaceholder = styled.div`
    position: relative;
    padding-top: 56.25%;
`;

export const FigureCaption = styled.figcaption`
    ${({ theme }) => css`
        font-size: 1rem;
        font-weight: 700;
        margin-bottom: 0.5rem;
        line-height: 1.2;

        @media ${theme.breakpoints.medium.media} {
            font-size: 1.25rem;
            margin-bottom: 0.75rem;
        }
    `}
`;

export const StyledLink = styled(Link)`
    display: block;
    margin-top: 0.5rem;
    font-size: 1.1125rem;
`;
